import { render, staticRenderFns } from "./BarberDataSheetsForm.vue?vue&type=template&id=cb3c7c34"
import script from "./BarberDataSheetsForm.vue?vue&type=script&lang=js"
export * from "./BarberDataSheetsForm.vue?vue&type=script&lang=js"
import style0 from "./BarberDataSheetsForm.vue?vue&type=style&index=0&id=cb3c7c34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports